/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import ConditionInserterConfiguration from 'embercom/objects/series/node/condition-inserter-configuration';

export default class ConditionNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new ConditionInserterConfiguration();
  category = NODE_CATEGORIES.condition;
}
